const EN_DATA = {
  menu: [
    "HOME",
    "SERVICES",
    "ABOUT US",
    "GALLERY",
    "CONTACT",
    "LOGIN",
    "LOGOUT",
    "STUDENT AREA",
  ],
  sections: {
    message: [
      "Important Notice!",
      "As a further education provider, the Barista Course By Bartira is still operating as usual during the pandemic restrictions. We are following all the guidelines to keep our students safe.",
    ],
    services: [
      "SERVICES",
      "Online Courses",
      "Face-to-face Courses",
      "See more",
    ],
    about: [
      "ABOUT US",
      "Located in the heart of Dublin, the Head Start Courses is formed by Bartira Augelli, an experienced and qualified professional focused on providing accessible services for the food sector, including“ Food Safety(HACCP - Level 1)” and“ Barista” courses.Our courses are available face to face or online, either English or Portuguese language, helping students who need effective and clear content to get a job in Ireland.",
      "With a simple, engaging and dynamic language, the Head Start Courses gives support by adequate training, and also helps the students with their Curriculum Vitae, with the objective to develop the necessary tools and confidence in order to distinguish our students toward the labour market, contributing to their personal and professional journey.",
      "MISSION",
      "Delivering knowledge in a light and efficient way and help the student to pursue a career in the food sector.",
      "VISION",
      "To become a benchmark in forming outstanding professionals of the Irish food sector, contributing to the student’s life and also with the country.",
      "VALUES",
      "Honesty, Integrity, Respect and Inclusion.",
      "WHO IS BARTIRA?",
      "“My business started when I realized that my tools and experience could create a positive impact on people’s lives, especially immigrants like me. Since then, my happiness is doing what I love, knowing that I can contribute to the start of so many professionals.”",
      "(BARTIRA)",
      `With over a decade of experience in the Irish food sector, I'm Bartira Augelli, the founder of Head Start Courses and the renowned Barista Course By Bartira. My academic background includes a Master of Science (Entrepreneurship) from Trinity College Dublin, a Master of Arts in Journalism and Media Communications from Griffith College Dublin, and a Bachelor of Business Studies (Honours) from International College Dublin. I also hold a Level 6 certification in "Advanced HACCP Design and Validation based on Risk Assessment."`,
      "My passion for teaching is central to my professional life, which led me to pursue a certification in Mentoring Training from Trinity College Dublin. Additionally, I am a certified Barista from the Specialty Coffee Association of Europe (SCAE).",
      `Over the past ten years, my barista course has successfully qualified over 7,000 professionals. Before the pandemic, I also ran a stylish coffee shop located in the British Studies Centres in Dublin 1. Following the pandemic, I opened a smaller teaching space also in Dublin 1, focusing on barista classes. After three years, `,
      `I relocated to a larger, stylish commercial unit in the heart of Stoneybatter.`,
      `It has always been my dream to establish a business there, as my barista classes align perfectly with the area's vibrant and inclusive atmosphere. Beyond my core business, I dedicate time to delivering talks, conducting training workshops, writing for the Dublin Inquirer, and participating in social programs. I occasionally teach barista skills to "hard-to-reach" young people from marginalised backgrounds in Dublin.`,
      "Check it out the video  and start today your professional journey!",
    ],
    contact: [
      "CONTACT US",
      "Fill out the fields below. We will answer you as soon as possible.",
      "Name",
      "Email",
      "Phone",
      "Subject",
      "Questions",
      "Technical Assistance",
      "Comments",
      "Other",
      "Message",
      "Send",
      "Location",
      "You can find Head Start Courses in:",
      "You are very welcome here. Will be our pleasure having you with us!",
      "* Free parking is available upon request",
    ],
    login: [
      "Email",
      "Password",
      "or Create a new account to go shopping ",
      "Forgot Password?",
    ],
    security: ["Security Policy"],
    cart: [
      "Shopping Cart",
      "Courses in Cart",
      "CHECKOUT",
      "Enter Voucher",
      "APPLIED",
      "APPLY",
      "Your cart is empty. Keep shopping!",
      "go shopping",
    ],
    coursecart: [
      "See more",
      "See available dates here!",
      "ADD TO CART",
      "Available days",
      "Time:",
      "Click here to buy it!",
      "Only",
      "spot(s) available",
      "No more spots available!",
      "No date available!",
      "We're still loading this class's data. Please try again in a moment.",
      "Already booked",
    ],
    dashboard: [
      "Hi",
      "EDIT",
      "Student",
      "DEADLINE:",
      "DATE COURSE:",
      "Finished",
      "Expired",
      "Open",
      "Purchased",
      "Schedule",
    ],
    editUser: ["Edit User", "Name", "Address", "Phone", "UPDATE", "CANCEL"],
    createUser: ["Your user has created successfully!", "Go to Login"],
    congratulations: [
      "Congratulations! You have finished the course: Food Safety - HACCP(Level 1).",
      "The certificate has been sent to your email!",
      "Back to Student Area",
    ],
    gallery: [
      "OUR GALLERY",
      "No images to be loaded",
      "Our Space",
      "Our Classes",
      "Our Story",
    ],
  },
}

export default EN_DATA
